import { FormBuilderControlType } from "@common/formbuilder/FormBuilderControlType";
import { SelectItem } from "primeng/components/common/selectitem";
import { IFieldOptions } from "../../framework/interfaces/IEntity";


export interface IFormBuilderControl {
  id?: any;
  displayName?: any;
  controlType?: FormBuilderControlType;
  bindingValue?: any;
  field?: any;
  lookups?: Array<SelectItem>
  validationFailed?: boolean;
  fieldOptions?: any;
}

export class FormBuilderControl  {
  id?: any;
  displayName?: any;
  controlType?: FormBuilderControlType;
  bindingValue?: any;
  field?: any;
  show?: Function;
  lookups?: Array<SelectItem>
  fieldOptions?: IFieldOptions
  disabled?: boolean;
  customControl?: any;
  requiredAnimation?: boolean;
  validationFailed?: boolean;
  blockSaving?: boolean;

  refreshLookups?: Function;

  constructor() { }
}
